import { SessionStorageKey } from '../enums/SessionStorageKey';

export function cleanLoginData() {
  sessionStorage.removeItem(SessionStorageKey.Token);
  sessionStorage.removeItem(SessionStorageKey.Username);
}
